import axios from 'axios';

export async function setQueueActivityState(organizationId, body) {
  const result = await axios.put(`/${organizationId}/queueState`, body)
  if(result.data.success) {
    return result.data.object
  }

  return false
}

